
class faqPageController extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      categories: this.querySelectorAll('faq-category-block'),
      questions: this.querySelectorAll('.question-block')
    }
    this.categories = [...this.elements.categories];
    this.questions = [...this.elements.questions];
    this.searchInput = this.querySelector('#faqSearch');
    this.searchForm = this.querySelector('#faq-search-form');
    
    this.searchInput.addEventListener('keyup', this.predictivSearch.bind(this));
    this.searchForm.addEventListener('submit', this.submitForm.bind(this));
    

    this.buildLandingAndNav();

    this.catLinks = this.querySelectorAll('.faq-cat-link');
    this.catLinks.forEach(
      (button) => {
        button.addEventListener('click', this.addCatLink.bind(this))
      }
    );

    this.quesLinks = this.querySelectorAll('.faq-ques-link');
    this.quesLinks.forEach(
      (button) => {
        button.addEventListener('click', this.addQuesLink.bind(this))
      }
    );

    this.returnLink = this.querySelector('.faq-page__return-landing');
    this.returnLink.addEventListener('click', this.returnLanding.bind(this));

    this.updatePage();
  }

  submitForm(e) {
    e.preventDefault();
    this.querySelector('#faq-page__h1-desc').scrollIntoView();
  }

  buildLandingAndNav() {
    const topSection = this.querySelector('.faq-top-section');
    const h1DescBlock = this.querySelector('#faq-page__h1-desc');
    const h1DescBlockClone = h1DescBlock.cloneNode(true);

    var newLandGridBlock = document.createElement("div");
    newLandGridBlock.id = 'faq-page__landing-grid';
    topSection.after(newLandGridBlock);

    h1DescBlock.parentNode.removeChild(h1DescBlock);
    topSection.after(h1DescBlockClone);

    var newNavBlock = document.createElement("div");
    newNavBlock.classList.add('faq-page__nav');

    let returnLink = document.createElement("a");
    returnLink.innerHTML = 'FAQ Categories';
    returnLink.setAttribute('href', "#");
    returnLink.classList.add('faq-page__return-landing');
    newNavBlock.appendChild(returnLink);

    topSection.after(newNavBlock);

    const faqLandingGrid = this.querySelector('#faq-page__landing-grid');

    this.categories.forEach(categoryEl => {
      const dataAtts = categoryEl.dataset;
      const catQuestions = categoryEl.querySelectorAll('faq-question');

      let newBlock = document.createElement("div");
      let title = document.createElement("a");
      title.innerHTML = dataAtts.categoryTitle;
      title.setAttribute('href', "#");
      title.classList.add('faq-page__landing-block-title', 'faq-cat-link', dataAtts.categoryIcon);
      title.setAttribute('data-cat-link', dataAtts.categoryHandle);
      newBlock.appendChild(title);

      let i = 1;
      catQuestions.forEach(question => {
        if (i < 5) {
          const dataAtts = question.dataset;
          let questionLink = document.createElement("a");
          questionLink.innerHTML = question.innerHTML;
          questionLink.setAttribute('href', "#");
          questionLink.classList.add('faq-page__landing-block-question', 'faq-ques-link');
          questionLink.setAttribute('data-cat-info', dataAtts.categoryHandle);
          questionLink.setAttribute('data-ques-link', dataAtts.questionHandle);
          newBlock.appendChild(questionLink);
          i++;
        }
      });

      if (catQuestions.length > 4) {
        let viewAll = document.createElement("a");
        viewAll.innerHTML = 'View All';
        viewAll.setAttribute('href', "#");
        viewAll.classList.add('faq-page__landing-block-viewall', 'faq-cat-link');
        viewAll.setAttribute('data-cat-link', dataAtts.categoryHandle);
        newBlock.appendChild(viewAll);
      }

      faqLandingGrid.appendChild(newBlock);
    })

    this.categories.forEach(categoryEl => {
      const navBlock = document.querySelector('.faq-page__nav');
      const dataAtts = categoryEl.dataset;
      let newLink = document.createElement("a");
      newLink.innerHTML = dataAtts.categoryTitle;
      newLink.setAttribute('href', "#");
      newLink.classList.add('faq-cat-link');
      newLink.setAttribute('data-cat-link', dataAtts.categoryHandle);
      navBlock.appendChild(newLink);
    })
  }

  predictivSearch(event) {
    const urlObj = new URL(window.location.href);
    const newUrl = urlObj.origin + urlObj.pathname + urlObj.search + '#category=all';
    window.location.href = newUrl;

    this.updatePage();
    this.classList.add('searching');
    
    const filterString = event.target.value.toLowerCase().trim();

    this.questions.forEach(qblock => {
      const dataAtts = qblock.dataset;

      if(filterString.length && !dataAtts.questionString.toLowerCase().includes(filterString)) return qblock.style.display = 'none'
      qblock.style.display = '';
    })

    this.categories.forEach(categoryEl => {
      categoryEl.elements = {
        catQuestions: categoryEl.querySelectorAll('faq-question')
      }

      const catQuestions = [...categoryEl.elements.catQuestions];
      const foundCount = catQuestions.filter(catQuestions => catQuestions.closest('.question-block').style.display !== 'none').length;

      if (foundCount == 0) {
        categoryEl.classList.add('zero-results');
      } else {
        categoryEl.classList.remove('zero-results');
      }
    })
    const totalFoundCount = this.questions.filter(foundQuestions => foundQuestions.closest('.question-block').style.display !== 'none').length;
    const countCntr = this.querySelector('.faq-block__questions-visible');
    totalFoundCount == 1 ? countCntr.innerHTML = totalFoundCount + ' FAQ found' : countCntr.innerHTML = totalFoundCount + ' FAQs found';
  }

  checkUrl() {
    let urlData;
    let urlReturn = {};
    const urlObj = new URL(window.location.href); 

    if (urlObj.hash.length != 0) {
      urlData = urlObj.hash.substring(1).split(';');
    }

    if (urlData) {
      if (urlData.length > 0) {
        urlReturn['category'] = urlData[0].split('=')[1];
        if (urlData.length > 1) {
          urlReturn['question'] = urlData[1].split('=')[1];
        }
      }
    }
    return urlReturn;
  }

  addCatLink(e) {
    e.preventDefault();

    this.resetSearch();
    this.closeAccordions();

    const urlData = this.checkUrl();
    if (e.target.getAttribute('data-cat-link') != urlData.category) {
      const urlObj = new URL(window.location.href); 
      const newUrl = urlObj.origin + urlObj.pathname + urlObj.search + '#category=' + e.target.getAttribute('data-cat-link');
      window.location.href = newUrl;

      this.updatePage();
    }
  }

  addQuesLink(e) {
    e.preventDefault();

    const urlData = this.checkUrl();
    const urlObj = new URL(window.location.href); 
    let newUrl = urlObj.origin + urlObj.pathname + urlObj.search + '#category=' + e.target.getAttribute('data-cat-info');

    if (urlData.question == undefined || urlData.question != e.target.getAttribute('data-ques-link')) {
      newUrl += ';question=' + e.target.getAttribute('data-ques-link');
    }

    window.location.href = newUrl;

    if (e.target.classList.contains('faq-page__landing-block-question')) {
      this.updatePage();
    }
  }

  updatePage() {
    const urlData = this.checkUrl();

    this.className = '';

    if (urlData.category) {
      this.classList.add('faq-category', urlData.category);

      this.categories.forEach(categoryEl => {
        const dataAtts = categoryEl.dataset;

        if (dataAtts.categoryHandle == urlData.category || urlData.category == 'all') {
          categoryEl.style.display = '';
          
          const catQuestions = categoryEl.querySelectorAll('faq-question');

          if (urlData.question && urlData.category != 'all') {
            catQuestions.forEach(question => {
              if (question.getAttribute('data-question-handle') == urlData.question) {
                question.closest('summary').click();
              }
            });
          }
        } else {
          categoryEl.style.display = 'none';
        }
      })
    } else {
      this.classList.add('faq-landing');
    }
  }

  resetSearch() {
    this.classList.remove('searching');

    this.searchInput.value = '';

    this.categories.forEach(categoryEl => {
      categoryEl.classList.remove('zero-results');

      const catQuestions = categoryEl.querySelectorAll('faq-question');

      const countCntr = this.querySelector('.faq-block__questions-visible');
      countCntr.innerHTML = '';
    })
    
    this.questions.forEach(qblock => {
      qblock.style.display = '';
    })
  }

  closeAccordions() {
    const openAccordions = this.querySelectorAll('details[open]');
    if (openAccordions.length > 0) {
      openAccordions.forEach(
        (accordion) => {
          accordion.querySelector('summary').click();
        }
      );
    }
  }

  returnLanding(e) {
    e.preventDefault();
    this.resetSearch();

    const urlObj = new URL(window.location.href); 
    const newUrl = urlObj.origin + urlObj.pathname + urlObj.search  + '#';

    window.location.href = newUrl;

    this.updatePage();
  }
}
customElements.define('faq-page-content', faqPageController);